import React, { useState } from 'react';
import '../../styles/BuildingPreviews/Community.css';
import CommunityChatbot from './CommunityChatbot';

const Community = ({ communityData }) => {
	const [isChatbotOpen, setIsChatbotOpen] = useState(false);
	
    return (
        <div className="community-container">
            {/* Header Section */}
			<div className="community-header">
			  <h2>🏙️ Harvard Square Overview</h2>
			  <p className="community-description-small">{communityData.communityDescription}</p>
			</div>

            <div className="community-grid">
                {/* Walk, Transit, Bike Scores */}
                <div className="community-section">
					<div className="score-cards">
					  <div className="score-card walk">🚶 Walking: {communityData.walkScore}</div>
					  <div className="score-card transit">🚇 Transit: {communityData.transitScore}</div>
					  <div className="score-card bike">🚲 Cycling:  {communityData.bikeScore}</div>
					</div>
                </div>

                {/* Schools Section */}
                <div className="community-section">
                    <h3>🏫 Nearby Schools</h3>
                    <div className="schools-list">
                        {communityData.nearbySchools.map((school, index) => (
                            <div key={index} className="school-card">
                                <strong>{school.name}</strong>
                                <p>📍 {school.distance} | ⭐ {school.rating}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Key Locations */}
                <div className="community-section">
                    <h3>📍 Key Locations</h3>
                    <div className="key-locations">
                        {communityData.keyLocations.map((location, index) => (
                            <div key={index} className="location-card">
                                <strong>{location.name}</strong>
                                <p>🗺️ {location.travelTime}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Neighborhood Essentials */}
                <div className="community-section">
                    <h3>📌 Neighborhood Essentials</h3>
                    <div className="essentials-list">
                        {communityData.essentials?.map((place, index) => (
                            <div key={index} className="essential-card">
                                <strong>{place.type}</strong>
                                <p>🏪 {place.name}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
			
			<div className="community-actions">
                {/* ✅ Show "Ask" button ONLY when chatbot is closed */}
                {!isChatbotOpen && (
                    <button className="chat-button" onClick={() => setIsChatbotOpen(true)}>
                        💬 Ask About This Area
                    </button>
                )}
                <button className="map-button">🗺️ View on Map</button>
            </div>

            {/* Floating Chatbot Button */}
            <CommunityChatbot isOpen={isChatbotOpen} onClose={() => setIsChatbotOpen(false)} />
        </div>
    );
};

export default Community;